window.TEV_PAIRINGS = [
  {
    ev_id: "tesla_model_3_rwd",
    ice_options: ["bmw_320i_auto", "bmw_320d_auto"],
    default_petrol_id: "bmw_320i_auto",
    default_diesel_id: "bmw_320d_auto",
    pairing_type: "segment_benchmark",
    confidence: "high",
    reason: "Similar UK market segment, size class and buyer use case."
  },
  {
    ev_id: "bmw_i4_edrive40",
    ice_options: ["bmw_320i_auto", "bmw_320d_auto"],
    default_petrol_id: "bmw_320i_auto",
    default_diesel_id: "bmw_320d_auto",
    pairing_type: "same_brand_segment",
    confidence: "high",
    reason: "Close premium family segment comparison."
  },
  {
    ev_id: "hyundai_kona_electric_65",
    ice_options: ["hyundai_kona_1_0t_petrol"],
    default_petrol_id: "hyundai_kona_1_0t_petrol",
    default_diesel_id: null,
    pairing_type: "same_model_family",
    confidence: "high",
    reason: "Same model family and same compact SUV use case."
  }
  ,
  {
    ev_id: "tesla_model_y_rwd",
    ice_options: ["vw_tiguan_1_5_tsi_petrol"],
    default_petrol_id: "vw_tiguan_1_5_tsi_petrol",
    default_diesel_id: null,
    pairing_type: "segment_benchmark",
    confidence: "high",
    reason: "Similar UK family SUV size and buyer use case."
  },
  {
    ev_id: "mg_mg4_urban_54",
    ice_options: ["vw_golf_1_5_tsi_petrol"],
    default_petrol_id: "vw_golf_1_5_tsi_petrol",
    default_diesel_id: null,
    pairing_type: "segment_benchmark",
    confidence: "high",
    reason: "Close mainstream hatchback class comparison."
  },
  {
    ev_id: "vw_id4_pure_52",
    ice_options: ["vw_tiguan_1_5_tsi_petrol"],
    default_petrol_id: "vw_tiguan_1_5_tsi_petrol",
    default_diesel_id: null,
    pairing_type: "same_brand_segment",
    confidence: "high",
    reason: "Comparable Volkswagen family SUV segment and use case."
  },
  {
    ev_id: "skoda_enyaq_edition_60",
    ice_options: ["skoda_karoq_1_5_tsi_petrol"],
    default_petrol_id: "skoda_karoq_1_5_tsi_petrol",
    default_diesel_id: null,
    pairing_type: "same_brand_segment",
    confidence: "high",
    reason: "Comparable Skoda SUV class and family-buyer use case."
  }
];